'use strict';

class DDSizeGuide extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-dd-size-trigger]');
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-dd-size-close]');

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.addEventListener('click', () => {
      this.dialog.showModal();
    });

    this.closeButton.addEventListener('click', () => {
      this.dialog.close();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => {
      this.trigger.focus();
    });
  }
}

if (!customElements.get('dd-size-guide')) {
  customElements.define('dd-size-guide', DDSizeGuide);
}

function initCreases() {
  if (typeof document === 'undefined') return;

  const creases = [...document.querySelectorAll('[data-dd-crease]')];
  if (creases.length === 0) return;

  const reducedMotion =
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || typeof IntersectionObserver === 'undefined') {
    creases.forEach((crease) => crease.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries.find((entry) => entry.isIntersecting);
      if (!visible) return;
      visible.target.classList.add('is-visible');
      observer.disconnect();
    },
    { threshold: 0.25 }
  );

  creases.forEach((crease) => observer.observe(crease));
}

/*
  Dawn's SliderComponent drives its rails with raw scrollLeft arithmetic. Under
  RTL, scrollLeft is negative in Chrome and Firefox and inverted in Safari, so
  the previous/next buttons move the wrong way and the page-dot state desyncs.

  Patching Dawn's slider internals would mean maintaining a fork of global.js
  for a five-product catalogue. Instead, under RTL we drop the slider chrome and
  let the rail behave as a plain scroll-snap container, which is natively
  direction-aware. The content stays fully reachable by touch, wheel, and
  keyboard; only the arrow buttons and dots go away.

  Revisit if the catalogue grows enough that carousel affordances matter.
*/
function disableSlidersUnderRtl() {
  if (typeof document === 'undefined') return;
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  document.querySelectorAll('slider-component').forEach((slider) => {
    slider.classList.add('dd-slider--native');

    slider.querySelectorAll('.slider-buttons').forEach((controls) => {
      controls.hidden = true;
    });

    // Dawn keys its scroll maths off this class; removing it stops the
    // component from trying to manage scroll position at all.
    slider.querySelectorAll('.slider--desktop, .slider--tablet').forEach((rail) => {
      rail.classList.add('dd-slider-rail');
    });
  });
}

initCreases();
disableSlidersUnderRtl();
